import createReducerMixin from "./createReducerMixin";

import Combiners from "abusesa-js/combiners";
import CombinerModel from "abusesa-js/ui/CombinerModel";

import TimeCombiner from "../lib/TimeCombiner";
import DataArray from "../lib/DataArray";
import Mappable from "lib/Mappable";

const COMBINER_PROPS = ["xKey", "yKey", "groupBy", "filter", "timespan", "granularity"];

const createCombinerModel = props => {
    let combiners = {
        "group": props["groupBy"] ?
            new Combiners.Unique(props["groupBy"], {"required": false}) :
            new Combiners.Dummy(),
        "x": props["xKey"] ?
            props["granularity"] ?
                new TimeCombiner(props["xKey"], props["granularity"], {timezone: props["timezone"]}) :
                new Combiners.Unique(props["xKey"]) :
            new Combiners.Dummy(),
        "y": props["yKey"] ?
            new Combiners.Sum(props["yKey"], {
                "header": props["yKey"]
            }) :
            new Combiners.Count({header: "# rows"})
    };

    let model = new CombinerModel(new Combiners.Group(combiners));

    return {model, combiners};
};

const getData = props => props.dataset || {name: null, data: []};

function reduce(state, nextProps, oldProps) {
    let {model, combiners, combined} = state;

    for (let i = 0; i < COMBINER_PROPS.length; i++) {
        let prop = COMBINER_PROPS[i];
        if (oldProps[prop] !== nextProps[prop]) {
            model = null;
            break;
        }
    }

    if (model == null || getData(oldProps).name !== getData(nextProps).name) {
        ({combiners, model} = createCombinerModel(nextProps));
    }

    if (getData(oldProps) !== getData(nextProps) || model !== state.model) {
        let newData = getData(nextProps).data;

        //we do an incremental incremental update to model if neither model or dataset has changed
        if (model === state.model && getData(oldProps).name === getData(nextProps).name) {
            newData = newData.slice(getData(oldProps).data.length);
        }

        newData.forEach(item => model.insert({event: item}));
    }

    if (model.hasChanges() || model !== state.model) {
        model.commit();

        combined = new DataArray(combiners);
        model.forEachRow(function(row) {
            let obj = {};
            model.columns().map(function(column) {
                obj[column.column] = model.renderer("text", column).render(row);
            });
            combined.push(obj);
        });
    }

    return {combined, model, combiners};
}

export default function combineDataset(WrappedComponent) {
    return class DataCombiner extends createReducerMixin(WrappedComponent, reduce) {
        static displayName = 'DataCombiner';

        render() {
            let rest = new Mappable(this.props)
                .filter((val, key) => !["dataset", ...COMBINER_PROPS].includes(key))
                .toObject();
            
            let {granularity} = this.props;

            let props = {...rest, data: this.state.combined, granularity};

            return super.render(props);
        }
    };
}



// WEBPACK FOOTER //
// ./src/kpi/common/DataCombiner.js